import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthInterceptor } from './auth.interceptor';
import { LogoutComponent } from './components/logout.component';
import { AuthSSOCallbackComponent } from './components/sso-callback.component';
import { OAuthModule } from 'angular-oauth2-oidc';
/**
 * AuthModule
 */
@NgModule({
  imports: [AuthRoutingModule, OAuthModule],
  declarations: [],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class AuthModule {}
